__webpack_require__.p = "https://bundle.stayforlong.com/20251111.7/_next/";